<template>
    <share-outfit-modal
        v-if="opened"
        :type="type || 'outfit'"
        :id="sharedId"
        @close="closed"
    />
</template>


<script>
    import {mapGetters} from "vuex";

    import ShareOutfitModal from "../outfit/share-outfit-modal.vue";

    export default {
        components: {
            ShareOutfitModal
        },
        computed: {
            ...mapGetters({
                sharedId: 'share/sharedId',
                type: 'share/shareType',
                opened: 'share/isShareModalOpened'
            }),
        },
        methods: {
            closed() {
                this.$store.commit('share/closeShareModal');
            },
        },
    }
</script>